// extracted by mini-css-extract-plugin
export default {"posts":"Journal_posts__Wr1Yo","slider":"Journal_slider__onRqb"};